import React, { useState } from 'react';
import Icon from 'components/AppIcon';

const STATUS_CONFIG = {
  new: {
    label: 'New Volunteer',
    className: 'status-new',
    icon: 'Sprout',
    description: 'Welcome! Complete your profile and enroll in orientation training to progress.',
    nextStatus: 'Trained',
    progressHint: 'Complete orientation to advance',
  },
  trained: {
    label: 'Trained',
    className: 'status-trained',
    icon: 'GraduationCap',
    description: 'You have completed basic training. Participate in volunteer activities to become Established.',
    nextStatus: 'Established',
    progressHint: 'Log 20+ volunteer hours to advance',
  },
  established: {
    label: 'Established',
    className: 'status-established',
    icon: 'Star',
    description: 'You are an established volunteer. Continue contributing to reach Senior status.',
    nextStatus: 'Senior',
    progressHint: 'Log 100+ volunteer hours to advance',
  },
  senior: {
    label: 'Senior Volunteer',
    className: 'status-senior',
    icon: 'Award',
    description: 'You have reached the highest volunteer status. Thank you for your dedication!',
    nextStatus: null,
    progressHint: 'You have reached the highest level!',
  },
};

export default function StatusIndicator({ status = 'new', showTooltip = true, size = 'default' }) {
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const config = STATUS_CONFIG?.[status] || STATUS_CONFIG?.new;

  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    default: '',
    lg: 'text-sm px-4 py-1.5',
  };

  return (
    <div className="relative inline-flex">
      <div
        className={`status-badge ${config?.className} ${sizeClasses?.[size]} cursor-default select-none`}
        onMouseEnter={() => showTooltip && setTooltipVisible(true)}
        onMouseLeave={() => setTooltipVisible(false)}
        onFocus={() => showTooltip && setTooltipVisible(true)}
        onBlur={() => setTooltipVisible(false)}
        tabIndex={showTooltip ? 0 : -1}
        role="status"
        aria-label={`Volunteer status: ${config?.label}`}
      >
        <Icon name={config?.icon} size={size === 'lg' ? 14 : 12} color="currentColor" />
        {config?.label}
      </div>
      {/* Tooltip */}
      {showTooltip && tooltipVisible && (
        <div
          className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-56 bg-card border border-border rounded-md shadow-lg p-3 z-50 animate-fade-in pointer-events-none"
          role="tooltip"
        >
          <p className="font-caption text-xs font-semibold text-foreground mb-1">{config?.label}</p>
          <p className="font-caption text-xs text-muted-foreground leading-relaxed">{config?.description}</p>
          {config?.nextStatus && (
            <div className="mt-2 pt-2 border-t border-border flex items-center gap-1.5">
              <Icon name="TrendingUp" size={11} color="var(--color-primary)" />
              <p className="font-caption text-xs text-primary">{config?.progressHint}</p>
            </div>
          )}
          {/* Tooltip arrow */}
          <div className="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-border" />
        </div>
      )}
    </div>
  );
}